import React, { useState, useEffect } from 'react';
import ExportExcel from '../../../container/export-excel/ExportExcel';
import LineForReport from '../../graph/line/LineForReport';
import ColumnForReport from '../../graph/bar/ColumnForReport';
import './ReportCreateResult.css';
import PieForReport from '../../graph/pie/PieForReport';
import TableForReport from '../../table/TableForReport';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import MapForReport from '../../graph/force-directed-tree/MapForReport';
import WordCloud from '../../graph/wordcloud/WordCloud';
import BubbleForReport from '../../graph/bubble/BubbleForReport';

const arrayCompare = (arr1, arr2) => {
  for (let i = 0; i < arr1.length || i < arr2.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
    else {
      continue;
    }
  }
  return true;
}

const ResultTab = (props) => {
  switch (props.reportType) {
    case "volume": {
      return (
        <>
          <a name="line" onClick={props.handleTabClick} className={props.tabState.lineTab}>Line</a>
          &nbsp;
          <a name="column" onClick={props.handleTabClick} className={props.tabState.columnTab}>Column</a>
          &nbsp;
          <a name="pie" onClick={props.handleTabClick} className={props.tabState.pieTab}>Pie</a>
          &nbsp;
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "source": {
      return (
        <>
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "sentiment": {
      return (
        <>
          <a name="line" onClick={props.handleTabClick} className={props.tabState.lineTab}>Line</a>
          &nbsp;
          <a name="column" onClick={props.handleTabClick} className={props.tabState.columnTab}>Column</a>
          &nbsp;
          <a name="pie" onClick={props.handleTabClick} className={props.tabState.pieTab}>Pie</a>
          &nbsp;
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "category": {
      return (
        <>
          <a name="map" onClick={props.handleTabClick} className={props.tabState.mapTab}>Map</a>
          &nbsp;
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "relation": {
      return (
        <>
          <a name="map" onClick={props.handleTabClick} className={props.tabState.mapTab}>Map</a>
          &nbsp;
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "positioningmap": {
      return (
        <>
          <a name="map" onClick={props.handleTabClick} className={props.tabState.mapTab}>Map</a>
          &nbsp;
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "buzzlist": {
      return (
        <>
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
    }
    case "channel_buzzlist": {
      return (
        <>
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
    }
    case "emotion": {
      return (
        <>
          {/* <a name="line" onClick={props.handleTabClick} className={props.tabState.lineTab}>Line</a>
          &nbsp; */}
          <a name="column" onClick={props.handleTabClick} className={props.tabState.columnTab}>Column</a>
          &nbsp;
          {/* <a name="pie" onClick={props.handleTabClick} className={props.tabState.pieTab}>Pie</a>
          &nbsp; */}
          <a name="table" onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    default:
      return null;
      break;
  }

}

const ReportResult = (props) => {
  //props.resultData
  switch (props.data.reportType) {
    case "volume": {
      if (props.presentGraph.graph == 'line') {
        return (
          // <ReportLine reportType={props.data.reportType} data={props.data.reportData} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc}/>
          <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}
          />
        )
      }
      else if (props.presentGraph.graph == 'column') {
        return (
          <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'pie') {
        return (
          <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "sentiment": {
      if (props.presentGraph.graph == 'line') {
        return (
          <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'column') {
        return (
          <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'pie') {
        return (
          <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "buzzlist": {
      if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "channel_buzzlist": {
      if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "source": {
      if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "category": {
      if (props.presentGraph.graph == 'map') {
        return (
          <ReportMap data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "relation": {
      if (props.presentGraph.graph == 'map') {
        return (
          <ReportMap data={props.data} excelExportFunc={props.excelExportFunc} />
        );
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "positioningmap": {
      if (props.presentGraph.graph == 'map') {
        return (
          <ReportMap data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "emotion": {
      // if (props.presentGraph.graph == 'line'){
      //   return (
      //     <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
      //   )
      // }
      if (props.presentGraph.graph == 'column') {
        return (
          <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      // else if (props.presentGraph.graph == 'pie'){
      //   return (
      //     <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole}/>
      //   )
      // }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    default:
      return null;
      break;
  }
}

const ReportMap = (props) => {
  switch (props.data.reportType) {
    case "category": {
      return (
        <Tabs style={{ margin: "10px" }}>
          <TabList style={{ display: "-webkit-box" }}>
            {props.data.reportData.map(item => {
              return (
                <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(item => {
            return (
              <TabPanel>
                <MapForReport type="report" reportName={props.data.name} width="100%" height={800} data={item.data} excelExportFunc={props.excelExportFunc} />
              </TabPanel>
            )
          })}
        </Tabs>
      )
    }
    case "relation": {
      return (
        <Tabs style={{ margin: "10px" }}>
          <TabList style={{ display: "-webkit-box" }}>
            {props.data.reportData.map(item => {
              return (
                <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(item => {
            return (
              <TabPanel>
                <Tabs style={{ margin: "10px" }}>
                  <TabList style={{ display: "-webkit-box" }}>
                    {item.data.map(wordItem => {
                      return (
                        <Tab>{wordItem.date}</Tab>
                      )
                    })}
                  </TabList>
                  {item.data.map(wordItem => {
                    return (
                      <TabPanel>
                        <div className="WordCloudContainer">
                          <div className="WordCloudTitle">
                            <span>{`# ${props.data.name}-${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]}) [${wordItem.date}]`}</span>
                            <div className="excel-btn-container">
                              <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
                            </div>
                          </div>
                          <WordCloud reportName={props.data.name} query={item.query} channel={item.channel} date={wordItem.date} data={wordItem.data} height={800} width={800} maxWords={100} />
                        </div>
                      </TabPanel>
                    )
                  })}
                </Tabs>
              </TabPanel>
            )
          })}
        </Tabs>
      )
    }
    case "positioningmap": {
      return (
        <Tabs style={{ margin: "10px" }}>
          <TabList style={{ display: "-webkit-box" }}>
            {props.data.reportData.map(item => {
              return (
                <Tab>{`${Channel_CODE_SET[item.channel]}`}</Tab>
              )
            })}
          </TabList>
          {props.data.reportData.map(item => {
            return (
              <TabPanel>
                <BubbleForReport width="100%" height={800} data={item.data} excelExportFunc={props.excelExportFunc} />
              </TabPanel>
            )
          })}
        </Tabs>
      )
    }
    default:
      return null;
      break;
  }
}

const ReportTable = (props) => {
  switch (props.data.reportType) {
    case "volume": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <TableForReport reportType={props.data.reportType} data={props.data} pageSize={10} />
        </div>
      )
      break;
    }
    case "sentiment": {
      let queryList = [];

      props.data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.query)
              }
            }
          })
        }
      })
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }}>
            <TabList style={{ display: "-webkit-box" }}>
              {queryList.map(item => {
                return (
                  <Tab>{item.join(' & ')}</Tab>
                )
              })}
            </TabList>
            {queryList.map(item => {
              return (
                <TabPanel>
                  <TableForReport pageSize={10} query={item} reportType={props.data.reportType} data={props.data} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "buzzlist": {
      return (
        <div className="buzzlist-table">
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }} >
            <TabList style={{ display: "-webkit-box" }}>
              {props.data.reportData.map(reportItem => {
                return (
                  <Tab>{`${reportItem.info.name.join(' & ')} (${Channel_CODE_SET[reportItem.info.code]})`}</Tab>
                )
              })}
            </TabList>
            {props.data.reportData.map(reportItem => {
              return (
                <TabPanel>
                  {/* <TableForReport options={props.data.options} pageSize={10} reportType={props.data.reportType} data={reportItem} /> */}
                  <TableForReport options={props.data.options} pageSize={10} reportType={props.data.reportType} data={reportItem.all} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "channel_buzzlist": {
      return (
        <div className="buzzlist-table">
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }} >
            <TabList style={{ display: "-webkit-box" }}>
              {props.data.reportData.map(reportItem => {
                return (
                  <Tab>{`${reportItem.info.name.join(' & ')} (${Channel_CODE_SET[reportItem.info.code]})`}</Tab>
                )
              })}
            </TabList>
            {props.data.reportData.map(reportItem => {
              return (
                <TabPanel>
                  <TableForReport options={props.data.options} pageSize={10} reportType={props.data.reportType} data={reportItem.all} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "source": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }} >
            <TabList style={{ display: "-webkit-box" }}>
              {props.data.reportData.map(reportItem => {
                return (
                  <Tab>{`${reportItem.info.query.join(' & ')} (${Channel_CODE_SET[reportItem.info.channel]})`}</Tab>
                )
              })}
            </TabList>
            {props.data.reportData.map(reportItem => {
              return (
                <TabPanel>
                  <TableForReport pageSize={10} reportType={props.data.reportType} data={reportItem} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "category": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }} >
            <TabList style={{ display: "-webkit-box" }}>
              {props.data.reportData.map(reportItem => {
                return (
                  <Tab>{`${reportItem.query.join(' & ')} (${Channel_CODE_SET[reportItem.channel]})`}</Tab>
                )
              })}
            </TabList>
            {props.data.reportData.map(reportItem => {
              return (
                <TabPanel>
                  <TableForReport pageSize={10} reportType={props.data.reportType} data={reportItem} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "positioningmap": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <TableForReport pageSize={10} reportType={props.data.reportType} data={props.data} />
        </div>
      )
      break;
    }
    case "relation": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }}>
            <TabList style={{ display: "-webkit-box" }}>
              {props.data.reportData.map(item => {
                return (
                  <Tab>{`${item.query.join(' & ')} (${Channel_CODE_SET[item.channel]})`}</Tab>
                )
              })}
            </TabList>
            {props.data.reportData.map(item => {
              return (
                <TabPanel>
                  <TableForReport options={props.data.options} reportType={props.data.reportType} data={item} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    case "emotion": {
      let queryList = [];

      props.data.reportData.forEach(item => {
        if (queryList.length == 0) {
          queryList.push(item.query);
        }
        else {
          queryList.some((query, index) => {
            if (arrayCompare(item.query, query)) {
              return true;
            }
            else {
              if (index == (queryList.length - 1)) {
                queryList.push(item.query)
              }
            }
          })
        }
      })
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <Tabs style={{ margin: "10px" }}>
            <TabList style={{ display: "-webkit-box" }}>
              {queryList.map(item => {
                return (
                  <Tab>{item.join(' & ')}</Tab>
                )
              })}
            </TabList>
            {queryList.map(item => {
              return (
                <TabPanel>
                  <TableForReport pageSize={10} query={item} reportType={props.data.reportType} data={props.data} />
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      )
      break;
    }
    default:
      return null;
      break;
  }
}

const ReportLine = (props) => {
  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        {props.data.reportData.map((item, index) => {
          let tabName = item.query.join(' & ');
          if (props.data.reportType == 'sentiment') {
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>
      {props.data.reportData.map((item, index) => (
        <TabPanel>
          <LineForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={800} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}
            mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels} userRole={props.userRole}
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}

const ReportColumn = (props) => {

  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        {props.data.reportData.map((item, index) => {
          let tabName = item.query.join(' & ');
          if (props.data.reportType == 'sentiment' || props.data.reportType == 'emotion') {
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>
      {props.data.reportData.map((item, index) => (
        <TabPanel>
          <ColumnForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={800} data={item} timeunit={props.timeunit} datatype={props.datatype} excelExportFunc={props.excelExportFunc}
            mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels}
            userRole={props.userRole}
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}

const ReportPie = (props) => {
  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        {props.data.reportData.map((item, index) => {
          let tabName = item.query.join(' & ');
          if (props.data.reportType == 'sentiment') {
            tabName = `${tabName}(${Channel_CODE_SET[item.channel]})`
          }
          return (
            <Tab>{tabName}</Tab>
          )
        })}
      </TabList>
      {props.data.reportData.map((item, index) => (
        <TabPanel>
          <PieForReport reportName={props.data.name} reportType={props.data.reportType} width="100%" height={800} data={item} excelExportFunc={props.excelExportFunc}
            mainQuery={props.data.mainQuery} subQuery={props.data.subQuery} subQueryType={props.data.subQueryType} reTweet={props.data.reTweet} channels={props.data.channels}
            userRole={props.userRole} type="report"
          />
        </TabPanel>
      ))}
    </Tabs>
  )
}


const ReportCreateResult = (props) => {
  // const [lineTab, setLineTab] = useState('button tabBlue_on');
  // const [columnTab, setColumnTab] = useState('button tabBlue_off');
  // const [pieTab, setPieTab] = useState('button tabBlue_off');
  // const [tableTab, setTableTab] = useState('button tabBlue_off');
  // const [mapTab, setMapTab] = useState('button tabBlue_off');
  const [tabState, setTabState] = useState({
    lineTab: 'button tabBlue_off',
    columnTab: 'button tabBlue_off',
    pieTab: 'button tabBlue_off',
    tableTab: 'button tabBlue_off',
    mapTab: 'button tabBlue_off'
  })
  const [presentGraph, setPresentGraph] = useState({
    reportType: "",
    graph: "",
  })
  // const [presentGraph, setPresentGraph] =useState('');
  //type이 볼륨이 아닐수있음

  useEffect(() => {
    if (props.data) {
      switch (props.data.reportType) {
        case "volume": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          break;
        }
        case "source": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          break;
        }
        case "buzzlist": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          break;
        }
        case "channel_buzzlist": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "table"
            })
          }
          break;
        }
        case "sentiment": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          break;
        }
        case "category": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          break;
        }
        case "relation": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          break;
        }
        case "positioningmap": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "map"
            })
          }
          break;
        }
        case "emotion": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "column"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "column"
            })
          }
          break;
        }
        default:
          break;
      }
    }
  }, [props.data])

  useEffect(() => {

    switch (presentGraph.graph) {
      case "line": {
        setTabState({
          lineTab: 'button tabBlue_on',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "column": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_on',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "table": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_on',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "pie": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_on',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "map": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_on'
        })
        break;
      }
      default:
        break;
    }

  }, [presentGraph.graph])

  const handleTabClick = (e) => {
    setPresentGraph({
      ...presentGraph,
      graph: e.target.getAttribute('name')
    })
  }
  return (
    <>
      {React.useMemo(() =>
        props.data ?
          <>
            <div className="graphType">
              <ResultTab reportType={props.data.reportType} tabState={tabState} handleTabClick={handleTabClick} />
            </div>
            <div className="output">
              <ReportResult presentGraph={presentGraph}
                data={props.data} timeunit={props.options.timeunit} datatype={props.options.datatype} excelExportFunc={() => ExportExcel('report-graph', props.data, props.userRole)}
                userRole={props.userRole}
              />
            </div>
          </>
          : <div style={{ height: "400px" }}></div>
        , [props.data, presentGraph, tabState])}

    </>
  )
}

export default ReportCreateResult;